import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { generatePath } from 'react-router-dom'
import { ROUTES } from 'helpers/constants'
import { CopyLink } from './'

const CopyPublicProfileLink = ({ username, className }) => {
  const publicProfilePath = useMemo(
    () => generatePath(ROUTES.PUBLIC_PROFILE, { slug: username }),
    [username]
  )

  return (
    <CopyLink link={publicProfilePath} className={className}>
      @{username}
    </CopyLink>
  )
}

CopyPublicProfileLink.propTypes = {
  className: PropTypes.string,
}

export default CopyPublicProfileLink
